module.exports = __webpack_public_path__ + "static/img/others_court.4ed1402d.png";